import request from './request'

export function fetchMediaAssets (params = {}) {
  return request.get('/media', { params })
}

export function uploadMediaAsset (file, module = '') {
  const formData = new FormData()
  formData.append('file', file)
  if (module) formData.append('module', module)

  return request.post('/media/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function updateMediaAsset (id, payload) {
  return request.put(`/media/${id}`, payload)
}

export function fetchMediaReferences (id) {
  return request.get(`/media/${id}/references`)
}

export function deleteMediaAsset (id) {
  return request.delete(`/media/${id}`)
}

export function resolveAssetUrl (fileUrl) {
  if (!fileUrl) return ''
  if (/^https?:\/\//.test(fileUrl)) return fileUrl

  const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api'
  const assetBaseUrl = apiBaseUrl.replace(/\/api\/?$/, '')
  const mediaBaseUrl = (process.env.VUE_APP_MEDIA_BASE_URL || assetBaseUrl).replace(/\/$/, '')
  if (fileUrl.startsWith('/assets/') || fileUrl.startsWith('/uploads/')) return `${mediaBaseUrl}${fileUrl}`

  const baseUrl = assetBaseUrl
  return `${baseUrl}${fileUrl}`
}
